<template>
	<v-navigation-drawer class="side-profile" width="410" v-model="open" touchless app fixed temporary overlay-opacity="0">
        <div class="side-profile-top">
            <div class="side-profile-top-avatar" @click="close()">
                <img v-if="customProfileIcon" :src="$imgUrl(customProfileIcon)" width="34">
                <img v-if=" ! customProfileIcon" src="@/assets/img/medal-challenge.png" width="34">
            </div>

            <div class="side-profile-top-name">{{ endUser.first_name }}</div>
            <div class="side-profile-top-close" @click="close()">
                <img src="@/assets/img/clear.png" width="21">
            </div>
        </div>

        <div class="side-profile-challenges" v-if="activeChallenges.length > 0">
            <h3 v-html="__('side_profile_active_challenges')"></h3>
            
            <div class="side-profile-challenges-item"
                v-for="challenge in activeChallenges"
                :key="challenge.id"
            >
                <div class="side-profile-challenges-item-check" @click="finish(challenge)">
                    <img src="@/assets/img/check.png" width="20">
                </div>

                <div class="side-profile-challenges-item-text">
                    <p>
                        <strong>{{ challenge.title }}</strong>
                        <br>
                        <span v-if="daysLeft(challenge)">{{ daysLeft(challenge) }} <span v-html="__('side_profile_active_challenges_days_left')"></span></span>
                    </p>
                </div>
            </div>
        </div>

		<div class="side-profile-accomplishments pa-9">
            <h3 v-html="__('side_profile_title')"></h3>      
            <p v-html="__('side_profile_intro')"></p>

            <div class="py-6">
                <div class="side-profile-accomplishments-item" @click="goToChallenges()">
                    <div>
                        <img src="@/assets/img/medal-challenge.png" width="50">
                    </div>
                    <div>
                        <h4 v-html="__('side_profile_challenge')"></h4>
                        <p>{{ finishedChallenges.length }} <span v-html="__('of')"></span> {{ challenges.length }}</p>
                    </div>
                </div>

                <div class="side-profile-challenges-with-status mb-5">
                    <div
                        v-for="(challenge, index) in challengesWithStatus"
                        :key="index"
                        :class="{finished: challenge.finished}"
                    >
                        {{ challenge.title }}
                    </div>
                </div>

                <div class="side-profile-accomplishments-item" @click="goToQuiz()">
                    <div>
                        <img src="@/assets/img/medal-quiz.png" width="40">
                    </div>
                    <div>
                        <h4 v-html="__('side_profile_quiz')"></h4>
                        <p>{{ finishedQuizes.length }} <span v-html="__('of')"></span> {{ quizes.length }}</p>
                    </div>
                </div>
            </div>
        </div>
	</v-navigation-drawer>
</template>

<script>
import moment from 'moment'
import scrollTo from 'scroll-to'

export default {
    name: 'SideProfile',
    props: [],

    data() {
    	return {
			
    	}
    },

    methods: {
        goToQuiz() {
            this.open = false
            scrollTo(0, window.scrollY + document.getElementsByClassName('quiz')[0].getBoundingClientRect().top - 100, {duration: 300})
        },

        goToChallenges() {
            this.open = false
            scrollTo(0, window.scrollY + document.getElementsByClassName('challenge')[0].getBoundingClientRect().top - 100, {duration: 300})
        },

        finish(challenge) {
            this.$store.commit('registerBehavior', {
                title: 'Finished',
                card_id: challenge.id,
                end_user_id: this.$store.state.endUser.id
            })
        },

        daysLeft(challenge) {
            let lastAccept = this.$store.state.endUser.behaviors
                .reduce((accepted, behavior) => {
                    if (behavior.card_id === challenge.id && behavior.title === 'Accepted') {
                        return behavior.created_at
                    }   
                })

            if ( ! lastAccept) {
                return null
            }

            let daysPassed = moment(lastAccept).diff(moment(), 'days')
            let daysLeft = parseInt(challenge.type_options.challenge_days) + daysPassed 

            return daysLeft >= 0 ? daysLeft : 0
        },

    	close() {
            this.open = false

            this.$metric({'event': 'coach_interaction', 'InteractionLocation': 'menu', 'InteractionType': 'closed'})
        }
    },

    computed: {
        customProfileIcon() {
            return this.$store.state.client?.custom_profile
        },

    	open: {
    	    get() { return this.$store.state.sideProfileOpen }, 
            set(open) { this.$store.state.sideProfileOpen = open }
    	},

        challengesWithStatus() {
            let challengesWithStatus = this.challenges.map(challenge => {
                let behaviors = this.$store.state.endUser.behaviors.filter(b => b.card_id === challenge.id)

                // Was it finished?
                if (behaviors.find(b => b.title === 'Finished')) {
                    return {
                        title: challenge.title,
                        finished: true
                    }
                } else {
                    // Was it failed?
                    let accepted = behaviors.find(b => b.title === 'Accepted')
                    
                    if (accepted) {
                        // Calculate days passed since it was accepted
                        let daysPassed = Math.abs(moment(accepted.created_at).diff(moment(), 'days'))
                        
                        if (daysPassed > challenge.type_options.challenge_days) {
                            return {
                                title: challenge.title,
                                finished: false
                            }
                        }
                    }
                }

                return null
            }).filter(n => n)

            return challengesWithStatus
        },

        endUser() {
            return this.$store.state.endUser
        },

        quizes() {
            return this.$store.getters.cards
                .filter(c => c.type === 'quiz')
        },

        finishedQuizes() {
            return this.quizes
                .filter(c => c.finished)
        },

        challenges() {
            return this.$store.getters.cards
                .filter(c => c.type === 'challenge')
        },

        activeChallenges() {
            return this.challenges
                .filter(c => c.accepted)  
        },

        finishedChallenges() {
            return this.challenges
                .filter(c => c.finished)
        }
    }
}
</script>